import { IRafflePrizeItem, Prize, TableRow } from '../components/base-components/RaffleDraw/types';
import { formatCurrency } from '../helpers/utils';

export const setPrize = (prize?: Prize): string | JSX.Element => {
  if (!prize) return '';

  switch (prize.type) {
    case 'money':
    case 'percent':
      return formatCurrency(prize.amount ?? 0, prize.currency ?? '');

    case 'externalPrize':
      return prize.description ?? '';

    default:
      return prize.description ?? '';
  }
};

export const transformRafflePrizePool = (data: IRafflePrizeItem[] = []): TableRow[] => {
  if (!data.length) return [];

  return [...data] // avoid mutating original array
    .sort((a, b) => a.place_from - b.place_from)
    .map((item) => ({
      place: item.place_from === item.place_to ? item.place_from : `${item.place_from}-${item.place_to}`,
      type: item.prize?.type,
      prize: setPrize(item.prize),
      currency: item.prize?.currency,
    }));
};
